/**
 * Replaces `{param}` placeholders in open API path templates.
 */
export function buildWidgetApiPath(
  template: string,
  params: Record<string, string>,
): string {
  let path = template;
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`{${key}}`, value);
  }
  return path;
}
